module.exports = __webpack_public_path__ + "img/icon_pagination_prev.1b66e057.svg";